import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Initialize Firebase here (before Angular bootstraps) so App Check attaches
// to the default app that AngularFire compat will reuse.
const firebaseApp = initializeApp(environment.firebaseConfig);

// Debug token lets localhost / non-production builds satisfy App Check without
// running reCAPTCHA Enterprise. Must be set BEFORE initializeAppCheck runs.
if (!environment.production && environment.appCheck?.debugToken) {
  (self as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN: string | boolean }).FIREBASE_APPCHECK_DEBUG_TOKEN =
    environment.appCheck.debugToken;
} else if (!environment.production) {
  // No explicit token — let the SDK print one to the console on first load so
  // the developer can register it in Firebase Console.
  (self as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN: boolean }).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// Only turn App Check on once a reCAPTCHA site key is configured. Until then
// the call is skipped so development and un-provisioned deploys still work.
if (environment.appCheck?.recaptchaSiteKey) {
  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaEnterpriseProvider(environment.appCheck.recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

// Disable console logs in production (keep console.error for error tracking)
// TEMPORARILY COMMENTED OUT FOR DEBUGGING
// if (environment.production) {
//   console.log = () => {};
//   console.debug = () => {};
//   console.info = () => {};
//   console.warn = () => {};
// }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));